// export const baseUrl = "http://localhost:8080/api/v1";
// export const baseUrl = "https://emporium-inn-server.vercel.app/api/v1";
export const baseUrl =
  "https://emporium-server-247255944173.europe-west2.run.app/api/v1";
